import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sessionAPI } from "../../api/sessionAPI.mjs";
import {
  fillMessages,
  fillSessionID,
  setNeedSendSatrtFalse,
  pushMessages,
  uploadFileMessage,
} from "../../store/slices/sessionSlice.mjs";
export default function HOC({ children }) {
  const dispatch = useDispatch();
  const sessionStore = useSelector((state) => state.session);
  const [sessionID, setSessionID] = useState(null);
  var mainaudio = new Audio();
  useEffect(() => {
    if (!localStorage.getItem("site-helper-sessionid")) {
      sessionAPI.getToken((sessionID_) => {
        localStorage.setItem("site-helper-sessionid", sessionID_);
        setSessionID(sessionID_);
      });
    } else {
      setSessionID(localStorage.getItem("site-helper-sessionid"));
    }
    sessionAPI.addEventTakeMessage((result) => {
      dispatch(pushMessages(result));
    });
    sessionAPI.addEventUploadFile((result) => {
      dispatch(uploadFileMessage(result));
    });
    sessionAPI.addEventSynthesizeSpeech((result) => {
      if (result.speech) {
        mainaudio.src = result.speech;
        mainaudio.play();
      }
    });
  }, []);
  useEffect(() => {
    if (sessionID) {
      sessionAPI.getMessages((result) => {
        dispatch(fillMessages(result));
      });
    }
  }, [sessionID]);
  useEffect(() => {
    if (sessionStore.needSendSatrt) {
      sessionAPI.sendMessage({
        message: "/start",
      });
      dispatch(setNeedSendSatrtFalse());
    }
  }, [sessionStore.needSendSatrt]);

  // useEffect(() => {
  //   console.log("messages", sessionStore.messages);
  // }, [sessionStore.messages]);

  return children;
}
